<template>
    <div>

        <vue-headful title="Subcontractor Import :: MeritEHS"/>

        <h4 class="py-3 mb-4">
            <ol class="breadcrumb font-weight-bold m-0">
                <li class="breadcrumb-item font-weight-light">
                    <router-link :to="`/subcontractors`">
                        <i class="fa fa-id-badge"></i> Subcontractors
                    </router-link>
                </li>
                <li class="breadcrumb-item active">
                    Import
                </li>
            </ol>
        </h4>

        <div class="card">
            <div class="card-body">
                <div class="alert alert-success">
                    <ul class="mb-0">
                        <li>File must be a CSV with the first row containing the columns names in this <a href="/documents/SubcontractorsImportTemplate.csv" target="_blank">Template</a></li>
                        <li>The company field is required</li>
                        <li>Blank fields will be ignored</li>
                        <li>Federal ID will be used if it is set, otherwise SSN will be used</li>
                    </ul>
                </div>
                <div v-bind:class="{ 'form-group': true, 'has-error': errors.files }" class="row">
                    <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right">File:</label>
                    <div class="col-sm-8">

                        <b-form-file v-model="file" class="mt-3" plain></b-form-file>

                        <span v-if="errors.files" class="text-danger">
                            <span v-for="error in errors.files">{{ error }}</span>
                        </span>
                    </div>
                </div>
            </div>
            <div class="card-footer">
                <button type="button" class="btn btn-success" @click="importFile" :disabled="saving">
                    Import File
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                loading: false,
                saving: false,
                file: [],
                errors: {},
            }
        },

        methods: {
            importFile: function() {
                //Show loading
                this.saving = true;

                //Reset the errors
                this.errors = {};

                //Send it
                this.$http
                .postWithFiles('subcontractors/import', {}, [this.file])
                .then(response => {
                    this.$toastr.success('Subcontractors Imported');

                    //Return to main list?
                    this.$router.push('/subcontractors');
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                })
                .then(response => {
                    //Show loading
                    this.saving = false;
                });
            }
        },
    }
</script>
